<template>
  <div>
    <div v-if="loading">
      <loader></loader>
    </div>
    <div id="canvas">
      <img class="previous-page" src="../../img/left.svg" value="previous" @click="pagePrev" />
      <img class="next-page" src="../../img/right.svg" value="next" @click="pageNext" />
      <div class="flipbook-viewport" id="mag">
        <div class="col-auto float-left bar">
          <router-link style="padding-right:90px" to="/home">Kiosk</router-link>
          <a to v-if="!index" @click="cambiarEstado('/index')">Index</a>
          <a to="/index" v-else @click="cambiarEstado('')">Close</a>
        </div>
        <div class="col-auto float-right">
          <a class="zoom-icon zoom-icon-in">Fullscreen</a>
        </div>
        <div class="container">
          <div class="flipbook" @keyup.right="pause" @keyup.left="pause" @click.prevent="pause">
            <div :style="'background-image:url(' + pages1[0] + ')'"></div>
            <div :style="'background-image:url(' + pages1[1] + ')'"></div>
            <div :style="'background-image:url(' + pages1[2] + ')'"></div>
            <div :style="'background-image:url(' + pages1[3] + ')'"></div>
            <div :style="'background-image:url(' + pages1[4] + ')'"></div>
            <div :style="'background-image:url(' + pages1[5] + ')'">
              <a
                class="minilinks articles"
                style="bottom:7.5%; left:42.2%; width: 15.5%"
                target="_blank"
                @click="openLink('mailto:info@missionmag.org')"
              >info@missionmag.org</a>
              <a
                class="minilinks articles"
                style="bottom:4%; left:39.8%; width: 20%"
                target="_blank"
                @click="openLink('mailto:advertising@missionmag.org')"
              >advertising@missionmag.org</a>
            </div>
            <div :style="'background-image:url(' + pages1[6] + ')'">
              <a
                class="minilinks articles"
                style="bottom:8.5%; left:43.2%; width: 13%"
                target="_blank"
                @click="openLink('http://missionmag.org/')"
              >http://missionmag.org/</a>
            </div>
            <div :style="'background-image:url(' + pages1[7] + ')'"></div>
            <div :style="'background-image:url(' + pages1[8] + ')'"></div>
            <div :style="'background-image:url(' + pages1[9] + ')'"></div>
            <div :style="'background-image:url(' + pages1[10] + ')'"></div>
            <div :style="'background-image:url(' + pages1[11] + ')'"></div>
            <div :style="'background-image:url(' + pages1[12] + ')'"></div>
            <div :style="'background-image:url(' + pages1[13] + ')'">
              <div class="dvf_left">
                <img :src="media[1]" alt="mission_diane_von_furstenburg" height="750%" width="824%" />
              </div>
              <a
                class="links"
                @click="onPlayerReadyMm(media[0])"
                style="bottom: 18%; left: 28%; width: 17%; font-size: 1vw;text-decoration:underline"
              >Click to Play</a>
            </div>
            <div :style="'background-image:url(' + pages1[14] + ')'">
              <div class="dvf_right">
                <img :src="media[2]" alt="mission_diane_von_furstenburg" height="750%" width="824%" />
              </div>
            </div>
            <div :style="'background-image:url(' + pages1[15] + ')'"></div>
            <div :style="'background-image:url(' + pages1[16] + ')'"></div>
            <div :style="'background-image:url(' + pages1[17] + ')'"></div>
            <div :style="'background-image:url(' + pages1[18] + ')'"></div>
            <div :style="'background-image:url(' + pages1[19] + ')'"></div>
            <div :style="'background-image:url(' + pages1[20] + ')'"></div>
            <div :style="'background-image:url(' + pages1[21] + ')'"></div>
            <div :style="'background-image:url(' + pages1[22] + ')'"></div>
            <div :style="'background-image:url(' + pages1[23] + ')'"></div>
            <div :style="'background-image:url(' + pages1[24] + ')'">
              <a
                class="links articles"
                style="bottom:7%; left:55.5%; width: 21%"
                target="_blank"
                @click="openLink('http://marymccartney.com/')"
              >http://marymccartney.com/</a>
            </div>
            <div :style="'background-image:url(' + pages1[25] + ')'"></div>
            <div :style="'background-image:url(' + pages1[26] + ')'"></div>
            <div :style="'background-image:url(' + pages1[27] + ')'">
              <vue-player
                ref="video1"
                id="witw1"
                src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-1%2Fmedia%2Fpg028_she_said_she_said_tina_brown.mp4?alt=media&token=4e1b0dca-3fc8-4b0c-af28-442227a56ab4"
                :poster="media[3]"
                play-button-class="play"
              ></vue-player>
            </div>
            <div :style="'background-image:url(' + pages1[28] + ')'" @change="pause"></div>
            <div :style="'background-image:url(' + pages1[29] + ')'"></div>
            <div :style="'background-image:url(' + pages1[30] + ')'">
              <vue-player
                ref="video2"
                id="witw2"
                src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-1%2Fmedia%2Fpg031_she_said_she_said_tina_brown.mp4?alt=media&token=07e39782-e0b8-4157-bdf1-d6143de388f8"
                :poster="media[4]"
              ></vue-player>
              <a
                class="links articles"
                style="bottom:7.1%; left:55.8%; width: 22%"
                target="_blank"
                @click="openLink('https://www.tinabrownmedia.com/')"
              >https://www.tinabrownmedia.com/</a>
            </div>
            <div :style="'background-image:url(' + pages1[31] + ')'"></div>
            <div :style="'background-image:url(' + pages1[32] + ')'"></div>
            <div :style="'background-image:url(' + pages1[33] + ')'"></div>
            <div :style="'background-image:url(' + pages1[34] + ')'"></div>
            <div :style="'background-image:url(' + pages1[35] + ')'"></div>
            <div :style="'background-image:url(' + pages1[36] + ')'">
              <vue-player
                ref="video3"
                id="workitout"
                src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-1%2Fmedia%2Fpg037_the_voice_texas_lets_workit_out_official_video.mp4?alt=media&token=b39ae208-4356-4309-9dea-becae0b1254a"
                :poster="media[5]"
              ></vue-player>
            </div>
            <div :style="'background-image:url(' + pages1[37] + ')'"></div>
            <div :style="'background-image:url(' + pages1[38] + ')'"></div>
            <div :style="'background-image:url(' + pages1[39] + ')'"></div>
            <div :style="'background-image:url(' + pages1[40] + ')'"></div>
            <div :style="'background-image:url(' + pages1[41] + ')'"></div>
            <div :style="'background-image:url(' + pages1[42] + ')'"></div>
            <div :style="'background-image:url(' + pages1[43] + ')'"></div>
            <div :style="'background-image:url(' + pages1[44] + ')'"></div>
            <div :style="'background-image:url(' + pages1[45] + ')'">
              <a
                class="links articles"
                style="bottom:58.1%; left:51.5%; width:10%"
                target="_blank"
                @click="openLink('https://edun.com/')"
              >https://edun.com/</a>
            </div>
            <div :style="'background-image:url(' + pages1[46] + ')'"></div>
            <div :style="'background-image:url(' + pages1[47] + ')'"></div>
            <div :style="'background-image:url(' + pages1[48] + ')'"></div>
            <div :style="'background-image:url(' + pages1[49] + ')'"></div>
            <div :style="'background-image:url(' + pages1[50] + ')'"></div>
            <div :style="'background-image:url(' + pages1[51] + ')'"></div>
            <div :style="'background-image:url(' + pages1[52] + ')'"></div>
            <div :style="'background-image:url(' + pages1[53] + ')'"></div>
            <div :style="'background-image:url(' + pages1[54] + ')'"></div>
            <div :style="'background-image:url(' + pages1[55] + ')'"></div>
            <div :style="'background-image:url(' + pages1[56] + ')'"></div>
            <div :style="'background-image:url(' + pages1[57] + ')'">
              <div class="mouth_left">
                <img :src="media[7]" alt="mouth_podcast" height="750%" width="824%" />
              </div>
              <a
                class="links"
                @click="onPlayerReadyLips(media[6])"
                style="bottom: 20%; left: 35%; width: 17%;font-size: 1vw;text-decoration:underline"
              >Click to Play</a>
            </div>
            <div :style="'background-image:url(' + pages1[58] + ')'">
              <div class="mouth_right">
                <img :src="media[8]" alt="mouth_podcast" height="750%" width="824%" />
              </div>
            </div>
            <div :style="'background-image:url(' + pages1[59] + ')'">
              <div class="skateboard_left">
                <img :src="media[10]" alt="stephan_skateboard" height="750%" width="824%" />
              </div>
              <a
                class="links"
                @click="onPlayerReadySkate(media[9])"
                style="bottom: 18%; left: 28%; width: 17%; font-size: 1vw; text-decoration:underline"
              >Click to Play</a>
            </div>
            <div :style="'background-image:url(' + pages1[60] + ')'">
              <div class="skateboard_right">
                <img :src="media[11]" alt="stephan_skateboard" height="750%" width="824%" />
              </div>
            </div>
            <div :style="'background-image:url(' + pages1[61] + ')'"></div>
            <div :style="'background-image:url(' + pages1[62] + ')'"></div>
            <div :style="'background-image:url(' + pages1[63] + ')'"></div>
            <div :style="'background-image:url(' + pages1[64] + ')'"></div>
            <div :style="'background-image:url(' + pages1[65] + ')'"></div>
            <div :style="'background-image:url(' + pages1[66] + ')'"></div>
            <div :style="'background-image:url(' + pages1[67] + ')'"></div>
            <div :style="'background-image:url(' + pages1[68] + ')'"></div>
            <div :style="'background-image:url(' + pages1[69] + ')'"></div>
            <div :style="'background-image:url(' + pages1[70] + ')'"></div>
            <div :style="'background-image:url(' + pages1[71] + ')'"></div>
            <div :style="'background-image:url(' + pages1[72] + ')'"></div>
            <div :style="'background-image:url(' + pages1[73] + ')'"></div>
            <div :style="'background-image:url(' + pages1[74] + ')'">
              <a
                class="links articles"
                style="bottom:7%; left:55.6%; width: 22.5%"
                target="_blank"
                @click="openLink('https://makelovenotporn.tv/')"
              >https://makelovenotporn.tv/</a>
            </div>
            <div :style="'background-image:url(' + pages1[75] + ')'"></div>
            <div :style="'background-image:url(' + pages1[76] + ')'"></div>
            <div :style="'background-image:url(' + pages1[77] + ')'"></div>
            <div :style="'background-image:url(' + pages1[78] + ')'"></div>
            <div :style="'background-image:url(' + pages1[79] + ')'"></div>
            <div :style="'background-image:url(' + pages1[80] + ')'">
              <a
                class="links articles"
                style="bottom:7%; left:53.5%; width: 19%"
                target="_blank"
                @click="openLink('http://visbalsculpture.com/')"
              >http://visbalsculpture.com/</a>
            </div>
            <div :style="'background-image:url(' + pages1[81] + ')'">
              <a
                class="links articles"
                style="bottom:7%; left:52.2%; width: 30%"
                target="_blank"
                @click="openLink('https://www.instagram.com/ashimashiraishi/')"
              >https://www.instagram.com/ashimashiraishi/</a>
            </div>
            <div :style="'background-image:url(' + pages1[82] + ')'"></div>
            <div :style="'background-image:url(' + pages1[83] + ')'"></div>
            <div :style="'background-image:url(' + pages1[84] + ')'"></div>
            <div :style="'background-image:url(' + pages1[85] + ')'"></div>
            <div :style="'background-image:url(' + pages1[86] + ')'"></div>
            <div :style="'background-image:url(' + pages1[87] + ')'"></div>
            <div :style="'background-image:url(' + pages1[88] + ')'"></div>
            <div :style="'background-image:url(' + pages1[89] + ')'"></div>
            <div :style="'background-image:url(' + pages1[90] + ')'"></div>
            <div :style="'background-image:url(' + pages1[91] + ')'"></div>
            <div :style="'background-image:url(' + pages1[92] + ')'">
              <a
                class="links articles"
                style="bottom:7%; left:56%; width: 22%"
                target="_blank"
                @click="openLink('https://www.williemaerockcamp.org/')"
              >https://www.williemaerockcamp.org/</a>
            </div>
            <div :style="'background-image:url(' + pages1[93] + ')'">
              <div class="harsh_crowd_left">
                <img :src="media[13]" alt="harsh_crowd" height="750%" width="824%" />
              </div>
              <a
                class="links"
                @click="onPlayerReadyBand(media[12])"
                style="bottom: 18%; left: 28%; width: 22%; font-size: 1em; text-decoration:underline"
              >Click to Play</a>
            </div>
            <div :style="'background-image:url(' + pages1[94] + ')'">
              <div class="harsh_crowd_right">
                <img :src="media[14]" alt="harsh_crowd" height="750%" width="824%" />
              </div>
            </div>
            <div :style="'background-image:url(' + pages1[95] + ')'">
              <a
                class="links articles"
                style="bottom:14.8%; left:53%; width: 12%"
                target="_blank"
                @click="openLink('https://www.instagram.com/harshcrowd/')"
              >https://www.instagram.com/harshcrowd/</a>
            </div>
            <div :style="'background-image:url(' + pages1[96] + ')'"></div>
            <div :style="'background-image:url(' + pages1[97] + ')'"></div>
            <div :style="'background-image:url(' + pages1[98] + ')'"></div>
            <div :style="'background-image:url(' + pages1[99] + ')'"></div>
            <div :style="'background-image:url(' + pages1[100] + ')'"></div>
            <div :style="'background-image:url(' + pages1[101] + ')'"></div>
            <div :style="'background-image:url(' + pages1[102] + ')'"></div>
            <div :style="'background-image:url(' + pages1[103] + ')'"></div>
            <div :style="'background-image:url(' + pages1[104] + ')'"></div>
            <div :style="'background-image:url(' + pages1[105] + ')'"></div>
            <div :style="'background-image:url(' + pages1[106] + ')'"></div>
            <div :style="'background-image:url(' + pages1[107] + ')'"></div>
            <div :style="'background-image:url(' + pages1[108] + ')'"></div>
            <div :style="'background-image:url(' + pages1[109] + ')'"></div>
            <div :style="'background-image:url(' + pages1[110] + ')'"></div>
            <div :style="'background-image:url(' + pages1[111] + ')'"></div>
            <div :style="'background-image:url(' + pages1[112] + ')'"></div>
            <div :style="'background-image:url(' + pages1[113] + ')'"></div>
            <div :style="'background-image:url(' + pages1[114] + ')'"></div>
            <div :style="'background-image:url(' + pages1[115] + ')'"></div>
            <div :style="'background-image:url(' + pages1[116] + ')'"></div>
            <div :style="'background-image:url(' + pages1[117] + ')'"></div>
            <div :style="'background-image:url(' + pages1[118] + ')'"></div>
            <div :style="'background-image:url(' + pages1[119] + ')'"></div>
            <div :style="'background-image:url(' + pages1[120] + ')'">
              <a
                class="links articles"
                style="bottom:7%; left:55.6%; width: 16%"
                target="_blank"
                @click="openLink('https://www.aijamayrock.com/')"
              >https://www.aijamayrock.com/</a>
            </div>
            <div :style="'background-image:url(' + pages1[121] + ')'">
              <a
                class="links articles"
                style="bottom:7%; left:52.4%; width: 21%"
                target="_blank"
                @click="openLink('https://www.instagram.com/sofiadangelo27/?hl=en')"
              >https://www.instagram.com/</a>
            </div>
            <div :style="'background-image:url(' + pages1[122] + ')'">
              <audio style="left:28%" id="sophia" controls>
                <source src="../../media/sophia_hold_tight_demo.mp3" type="audio/mpeg" />
              </audio>
            </div>
            <div :style="'background-image:url(' + pages1[123] + ')'"></div>
            <div :style="'background-image:url(' + pages1[124] + ')'"></div>
            <div :style="'background-image:url(' + pages1[125] + ')'"></div>
            <div :style="'background-image:url(' + pages1[126] + ')'"></div>
            <div :style="'background-image:url(' + pages1[127] + ')'">
              <a
                class="links articles"
                style="bottom:7%; left:51.5%; width: 17.2%"
                target="_blank"
                @click="openLink('https://michelepred.com/home.html')"
              >https://michelepred.com/home.html</a>
            </div>
            <div :style="'background-image:url(' + pages1[128] + ')'"></div>
            <div :style="'background-image:url(' + pages1[129] + ')'"></div>
            <div :style="'background-image:url(' + pages1[130] + ')'"></div>
            <div :style="'background-image:url(' + pages1[131] + ')'"></div>
            <div :style="'background-image:url(' + pages1[132] + ')'"></div>
            <div :style="'background-image:url(' + pages1[133] + ')'"></div>
            <div :style="'background-image:url(' + pages1[134] + ')'"></div>
            <div :style="'background-image:url(' + pages1[135] + ')'"></div>
            <div :style="'background-image:url(' + pages1[136] + ')'">
              <a
                class="links articles"
                style="bottom:7%; left:55.5%; width:19%"
                target="_blank"
                @click="openLink('https://www.aliforneycenter.org/')"
              >https://www.aliforneycenter.org/</a>
            </div>
            <div :style="'background-image:url(' + pages1[137] + ')'"></div>
            <div :style="'background-image:url(' + pages1[138] + ')'"></div>
            <div :style="'background-image:url(' + pages1[139] + ')'">
              <vue-player
                ref="video4"
                id="wonder_woman"
                src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-1%2Fmedia%2Fpg140_wonder_woman.mp4?alt=media&token=e294d0e0-926c-4d35-a41e-f16b2b77067c"
                :poster="media[15]"
              ></vue-player>
            </div>
            <div :style="'background-image:url(' + pages1[140] + ')'"></div>
            <div :style="'background-image:url(' + pages1[141] + ')'"></div>
            <div :style="'background-image:url(' + pages1[142] + ')'"></div>
            <div :style="'background-image:url(' + pages1[143] + ')'">
              <vue-player
                ref="video5"
                id="kiss_the_girls"
                src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-1%2Fmedia%2Fpg144_kiss_the_girls.mp4?alt=media&token=bcf968c2-1060-42d7-bd19-2d582093cac6"
                :poster="media[16]"
              ></vue-player>
            </div>
            <div :style="'background-image:url(' + pages1[144] + ')'"></div>
            <div :style="'background-image:url(' + pages1[145] + ')'">
              <vue-player
                ref="video6"
                id="pm_magazine"
                src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-1%2Fmedia%2Fpg146_pm_magazine.mp4?alt=media&token=05af0cac-4592-4a6b-b80f-8fec69fc6747"
                :poster="media[17]"
              ></vue-player>
            </div>
            <div :style="'background-image:url(' + pages1[146] + ')'">
              <a
                class="links articles"
                style="bottom:9.6%; left:55.5%; width: 28%"
                target="_blank"
                @click="openLink('https://www.mariangoodman.com/artists/dara-birnbaum/')"
              >mariangoodman</a>
            </div>
            <div :style="'background-image:url(' + pages1[147] + ')'"></div>
            <div :style="'background-image:url(' + pages1[148] + ')'"></div>
            <div :style="'background-image:url(' + pages1[149] + ')'"></div>
            <div :style="'background-image:url(' + pages1[150] + ')'"></div>
            <div :style="'background-image:url(' + pages1[151] + ')'"></div>
            <div :style="'background-image:url(' + pages1[152] + ')'"></div>
            <div :style="'background-image:url(' + pages1[153] + ')'"></div>
            <div :style="'background-image:url(' + pages1[154] + ')'"></div>
            <div :style="'background-image:url(' + pages1[155] + ')'"></div>
            <div :style="'background-image:url(' + pages1[156] + ')'"></div>
            <div :style="'background-image:url(' + pages1[157] + ')'"></div>
            <div :style="'background-image:url(' + pages1[158] + ')'"></div>
            <div :style="'background-image:url(' + pages1[159] + ')'"></div>
            <div :style="'background-image:url(' + pages1[160] + ')'"></div>
            <div :style="'background-image:url(' + pages1[161] + ')'"></div>
            <div :style="'background-image:url(' + pages1[162] + ')'"></div>
            <div :style="'background-image:url(' + pages1[163] + ')'"></div>
            <div :style="'background-image:url(' + pages1[164] + ')'"></div>
            <div :style="'background-image:url(' + pages1[165] + ')'"></div>
            <div :style="'background-image:url(' + pages1[166] + ')'"></div>
            <div :style="'background-image:url(' + pages1[167] + ')'"></div>
            <div :style="'background-image:url(' + pages1[168] + ')'"></div>
            <div :style="'background-image:url(' + pages1[169] + ')'"></div>
            <div :style="'background-image:url(' + pages1[170] + ')'"></div>
            <div :style="'background-image:url(' + pages1[171] + ')'"></div>
            <div :style="'background-image:url(' + pages1[172] + ')'"></div>
            <div :style="'background-image:url(' + pages1[173] + ')'"></div>
            <div :style="'background-image:url(' + pages1[174] + ')'"></div>
            <div :style="'background-image:url(' + pages1[175] + ')'"></div>
            <div :style="'background-image:url(' + pages1[176] + ')'"></div>
            <div :style="'background-image:url(' + pages1[177] + ')'"></div>
            <div :style="'background-image:url(' + pages1[178] + ')'"></div>
            <div :style="'background-image:url(' + pages1[179] + ')'"></div>
            <div :style="'background-image:url(' + pages1[180] + ')'"></div>
            <div :style="'background-image:url(' + pages1[181] + ')'">
              <vue-player
                ref="video7"
                id="beach"
                src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-1%2Fmedia%2Fpg182_julietta_beach_break_official_music_video.mp4?alt=media&token=62d1503a-6fa4-48ce-8fed-28b3f0267c47"
                :poster="media[18]"
              ></vue-player>
            </div>
            <div :style="'background-image:url(' + pages1[182] + ')'"></div>
            <div :style="'background-image:url(' + pages1[183] + ')'"></div>
            <div :style="'background-image:url(' + pages1[184] + ')'"></div>
            <div :style="'background-image:url(' + pages1[185] + ')'"></div>
            <div :style="'background-image:url(' + pages1[186] + ')'"></div>
            <div :style="'background-image:url(' + pages1[187] + ')'"></div>
            <div :style="'background-image:url(' + pages1[188] + ')'"></div>
            <div :style="'background-image:url(' + pages1[189] + ')'"></div>
            <div :style="'background-image:url(' + pages1[190] + ')'"></div>
            <div :style="'background-image:url(' + pages1[191] + ')'"></div>
            <div :style="'background-image:url(' + pages1[192] + ')'"></div>
            <div :style="'background-image:url(' + pages1[193] + ')'"></div>
            <div :style="'background-image:url(' + pages1[194] + ')'"></div>
            <div :style="'background-image:url(' + pages1[195] + ')'"></div>
            <div :style="'background-image:url(' + pages1[196] + ')'"></div>
            <div :style="'background-image:url(' + pages1[197] + ')'"></div>
            <div :style="'background-image:url(' + pages1[198] + ')'">
              <a
                class="links articles"
                style="bottom:7%; left:56%; width: 19%"
                target="_blank"
                @click="openLink('https://www.gabrielahearst.com/')"
              >https://www.gabrielahearst.com/</a>
            </div>
            <div :style="'background-image:url(' + pages1[199] + ')'">
              <a
                class="links articles"
                style="bottom:14.8%; left:53%; width: 25.5%"
                target="_blank"
                @click="openLink('https://www.instagram.com/harshcrowd/')"
              >https://www.instagram.com/harshcrowd/</a>
            </div>
            <div :style="'background-image:url(' + pages1[200] + ')'"></div>
            <div :style="'background-image:url(' + pages1[201] + ')'"></div>
            <div :style="'background-image:url(' + pages1[202] + ')'"></div>
            <div :style="'background-image:url(' + pages1[203] + ')'"></div>
            <div :style="'background-image:url(' + pages1[204] + ')'">
              <vue-player
                ref="video8"
                id="makers"
                src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-1%2Fmedia%2Fpg205_makers_mark.mp4?alt=media&token=6319a49d-4b0d-4406-b1a9-a0de5785196d"
                :poster="media[19]"
              ></vue-player>
            </div>
            <div :style="'background-image:url(' + pages1[205] + ')'"></div>
            <div :style="'background-image:url(' + pages1[206] + ')'">
              <a
                class="links articles"
                style="bottom:7%; left:55.6%; width: 12.8%"
                target="_blank"
                @click="openLink('https://www.mcgeemedia.com/dyllan-mcgee')"
              >dyllan-mcgee</a>
            </div>
            <div :style="'background-image:url(' + pages1[207] + ')'"></div>
            <div :style="'background-image:url(' + pages1[208] + ')'"></div>
            <div :style="'background-image:url(' + pages1[209] + ')'"></div>
            <div :style="'background-image:url(' + pages1[210] + ')'"></div>
            <div :style="'background-image:url(' + pages1[211] + ')'"></div>
            <div :style="'background-image:url(' + pages1[212] + ')'"></div>
            <div :style="'background-image:url(' + pages1[213] + ')'"></div>
            <div :style="'background-image:url(' + pages1[214] + ')'"></div>
            <div :style="'background-image:url(' + pages1[215] + ')'"></div>
            <div :style="'background-image:url(' + pages1[216] + ')'"></div>
            <div :style="'background-image:url(' + pages1[217] + ')'"></div>
            <div :style="'background-image:url(' + pages1[218] + ')'"></div>
            <div :style="'background-image:url(' + pages1[219] + ')'"></div>
            <div :style="'background-image:url(' + pages1[220] + ')'"></div>
            <div :style="'background-image:url(' + pages1[221] + ')'">
              <a
                class="links articles"
                style="bottom:7%; left:51.5%; width: 9%"
                target="_blank"
                @click="openLink('https://miclu.org/')"
              >https://miclu.org/</a>
            </div>
            <div :style="'background-image:url(' + pages1[222] + ')'"></div>
            <div :style="'background-image:url(' + pages1[223] + ')'"></div>
            <div :style="'background-image:url(' + pages1[224] + ')'"></div>
            <div :style="'background-image:url(' + pages1[225] + ')'"></div>
            <div :style="'background-image:url(' + pages1[226] + ')'">
              <a
                class="drawing_pdfs"
                target="_blank"
                style="bottom:6.5%; left:77.5%; width: 9%;text-decoration:underline;cursor:pointer"
                @click="openBook"
              >HERE.</a>
            </div>
            <div :style="'background-image:url(' + pages1[227] + ')'"></div>
            <div :style="'background-image:url(' + pages1[228] + ')'"></div>
            <div :style="'background-image:url(' + pages1[229] + ')'"></div>
            <div :style="'background-image:url(' + pages1[230] + ')'"></div>
            <div :style="'background-image:url(' + pages1[231] + ')'"></div>
            <div :style="'background-image:url(' + pages1[232] + ')'"></div>
            <div :style="'background-image:url(' + pages1[233] + ')'"></div>
            <div :style="'background-image:url(' + pages1[234] + ')'"></div>
            <div :style="'background-image:url(' + pages1[235] + ')'"></div>
            <div :style="'background-image:url(' + pages1[236] + ')'"></div>
            <div :style="'background-image:url(' + pages1[237] + ')'"></div>
            <div :style="'background-image:url(' + pages1[238] + ')'">
              <a
                class="links articles"
                style="bottom:70.8%; left:55.5%; width: 22%"
                target="_blank"
                @click="openLink('http://www.codetoinspire.org/')"
              >http://www.codetoinspire.org/</a>
            </div>
            <div :style="'background-image:url(' + pages1[239] + ')'"></div>
            <div :style="'background-image:url(' + pages1[240] + ')'">
              <a
                class="links articles"
                style="bottom:81%; left:57%; width: 24%"
                target="_blank"
                @click="openLink('https://www.instagram.com/harshcrowd/')"
              >https://www.instagram.com/harshcrowd/</a>
            </div>
            <div :style="'background-image:url(' + pages1[241] + ')'"></div>
            <div :style="'background-image:url(' + pages1[242] + ')'"></div>
            <div :style="'background-image:url(' + pages1[243] + ')'"></div>
            <div :style="'background-image:url(' + pages1[244] + ')'"></div>
            <div :style="'background-image:url(' + pages1[245] + ')'"></div>
            <div :style="'background-image:url(' + pages1[246] + ')'"></div>
            <div :style="'background-image:url(' + pages1[247] + ')'"></div>
            <div :style="'background-image:url(' + pages1[248] + ')'"></div>
            <div :style="'background-image:url(' + pages1[249] + ')'"></div>
            <div :style="'background-image:url(' + pages1[250] + ')'">
              <a
                class="links articles"
                style="bottom:6.9%; left:55.6%; width: 20%"
                target="_blank"
                @click="openLink('https://lesbianswhotech.org/virtualpridesummit/')"
              >https://lesbianswhotech.org/virtualpridesummit/</a>
            </div>
            <div :style="'background-image:url(' + pages1[251] + ')'"></div>
            <div :style="'background-image:url(' + pages1[252] + ')'">
              <a
                class="links articles"
                style="bottom:63.2%; left:57%; width: 25%"
                target="_blank"
                @click="openLink('https://www.instagram.com/erinwinick/')"
              >https://www.instagram.com/erinwinick/</a>
            </div>
            <div :style="'background-image:url(' + pages1[253] + ')'"></div>
            <div :style="'background-image:url(' + pages1[254] + ')'"></div>
            <div :style="'background-image:url(' + pages1[255] + ')'"></div>
            <div :style="'background-image:url(' + pages1[256] + ')'"></div>
            <div :style="'background-image:url(' + pages1[257] + ')'"></div>
            <div :style="'background-image:url(' + pages1[258] + ')'"></div>
            <div :style="'background-image:url(' + pages1[259] + ')'"></div>
            <div :style="'background-image:url(' + pages1[260] + ')'">
              <a
                class="links articles"
                style="bottom:6.5%; left:10.5%; width: 30%"
                target="_blank"
                @click="openLink('http://hairbychristiaan.com/')"
              >http://hairbychristiaan.com/</a>
            </div>
            <div :style="'background-image:url(' + pages1[261] + ')'"></div>
            <div :style="'background-image:url(' + pages1[262] + ')'"></div>
            <div :style="'background-image:url(' + pages1[263] + ')'"></div>
            <div :style="'background-image:url(' + pages1[264] + ')'"></div>
            <div :style="'background-image:url(' + pages1[265] + ')'"></div>
            <div :style="'background-image:url(' + pages1[266] + ')'"></div>
            <div :style="'background-image:url(' + pages1[267] + ')'"></div>
            <div :style="'background-image:url(' + pages1[268] + ')'"></div>
            <div :style="'background-image:url(' + pages1[269] + ')'"></div>
            <div :style="'background-image:url(' + pages1[270] + ')'">
              <a
                class="links articles"
                style="bottom:73.4%; left:57%; width: 31%"
                target="_blank"
                @click="openLink('https://www.instagram.com/victoriapannell/')"
              >https://www.instagram.com/victoriapannell/</a>
            </div>
            <div :style="'background-image:url(' + pages1[271] + ')'"></div>
            <div :style="'background-image:url(' + pages1[272] + ')'">
              <a
                class="links articles"
                style="bottom:58%; left:55.6%; width: 25%"
                target="_blank"
                @click="openLink('http://autism.sesamestreet.org/')"
              >http://autism.sesamestreet.org/</a>
            </div>
            <div :style="'background-image:url(' + pages1[273] + ')'">
              <div class="sesame_street_left">
                <img :src="media[22]" alt="sesame_street" height="750%" width="824%" />
              </div>
              <a
                class="links"
                @click="onPlayerReadySesame(media[21])"
                style="bottom: 18%; left: 28%; width: 22%; font-size: 1em; border-bottom:none !important"
              >Click to Play</a>
            </div>
            <div :style="'background-image:url(' + pages1[274] + ')'">
              <div class="sesame_street_right">
                <img :src="media[23]" alt="sesame_street" height="750%" width="824%" />
              </div>
            </div>
            <div :style="'background-image:url(' + pages1[275] + ')'"></div>
            <div :style="'background-image:url(' + pages1[276] + ')'"></div>
            <div :style="'background-image:url(' + pages1[277] + ')'"></div>
            <div :style="'background-image:url(' + pages1[278] + ')'"></div>
            <div :style="'background-image:url(' + pages1[279] + ')'"></div>
            <div :style="'background-image:url(' + pages1[280] + ')'"></div>
            <div :style="'background-image:url(' + pages1[281] + ')'"></div>
            <div :style="'background-image:url(' + pages1[282] + ')'"></div>
            <div :style="'background-image:url(' + pages1[283] + ')'"></div>
            <div :style="'background-image:url(' + pages1[284] + ')'"></div>
            <div :style="'background-image:url(' + pages1[285] + ')'"></div>
            <div :style="'background-image:url(' + pages1[286] + ')'"></div>
            <div :style="'background-image:url(' + pages1[287] + ')'"></div>
            <div :style="'background-image:url(' + pages1[288] + ')'"></div>
            <div :style="'background-image:url(' + pages1[289] + ')'"></div>
            <div :style="'background-image:url(' + pages1[290] + ')'"></div>
            <div :style="'background-image:url(' + pages1[291] + ')'"></div>
            <div :style="'background-image:url(' + pages1[292] + ')'"></div>
            <div :style="'background-image:url(' + pages1[293] + ')'"></div>
            <div :style="'background-image:url(' + pages1[294] + ')'"></div>
            <div :style="'background-image:url(' + pages1[295] + ')'"></div>
            <div :style="'background-image:url(' + pages1[296] + ')'"></div>
            <div :style="'background-image:url(' + pages1[297] + ')'">
              <a
                class="links articles"
                style="bottom:7%; left:52.5%; width:32%"
                target="_blank"
                @click="openLink('https://www.instagram.com/astronautabbyofficial/')"
              >https://www.instagram.com/astronautabbyofficial/</a>
            </div>
            <div :style="'background-image:url(' + pages1[298] + ')'"></div>
            <div :style="'background-image:url(' + pages1[299] + ')'"></div>
            <div :style="'background-image:url(' + pages1[300] + ')'"></div>
            <div :style="'background-image:url(' + pages1[301] + ')'"></div>
            <div :style="'background-image:url(' + pages1[302] + ')'"></div>
            <div :style="'background-image:url(' + pages1[303] + ')'"></div>
            <div :style="'background-image:url(' + pages1[304] + ')'">
              <a
                class="links articles"
                style="bottom:55.5%; left:55.8%; width: 16%"
                target="_blank"
                @click="openLink('https://www.therealreal.com/')"
              >https://www.therealreal.com/</a>
            </div>
            <div :style="'background-image:url(' + pages1[305] + ')'"></div>
            <div :style="'background-image:url(' + pages1[306] + ')'"></div>
            <div :style="'background-image:url(' + pages1[307] + ')'"></div>
            <div :style="'background-image:url(' + pages1[308] + ')'"></div>
            <div :style="'background-image:url(' + pages1[309] + ')'">
              <a
                class="links articles"
                style="top:34.5%; left:51.5%; width: 18%"
                target="_blank"
                @click="openLink('https://studiomuseum.org/')"
              >https://studiomuseum.org/</a>
            </div>
            <div :style="'background-image:url(' + pages1[310] + ')'"></div>
            <div :style="'background-image:url(' + pages1[311] + ')'"></div>
            <div :style="'background-image:url(' + pages1[312] + ')'"></div>
            <div :style="'background-image:url(' + pages1[313] + ')'"></div>
            <div :style="'background-image:url(' + pages1[314] + ')'">
              <a
                class="links articles"
                style="bottom:7%; left:55.8%; width: 15%"
                target="_blank"
                @click="openLink('https://freethework.com/')"
              >https://freethework.com/</a>
            </div>
            <div :style="'background-image:url(' + pages1[315] + ')'"></div>
            <div :style="'background-image:url(' + pages1[316] + ')'"></div>
            <div :style="'background-image:url(' + pages1[317] + ')'"></div>
            <div :style="'background-image:url(' + pages1[318] + ')'"></div>
            <div :style="'background-image:url(' + pages1[319] + ')'"></div>
            <div :style="'background-image:url(' + pages1[320] + ')'"></div>
            <div :style="'background-image:url(' + pages1[321] + ')'"></div>
            <div :style="'background-image:url(' + pages1[322] + ')'">
              <a
                class="links articles"
                style="bottom:47.8%; left:55.6%; width: 23.5%"
                target="_blank"
                @click="openLink('http://www.prettybigmovement.com/')"
              >http://www.prettybigmovement.com/</a>
            </div>
            <div :style="'background-image:url(' + pages1[323] + ')'">
              <div class="pbm_left">
                <img :src="media[25]" alt="pretty_big_movement" height="750%" width="824%" />
              </div>
              <a
                class="links"
                @click="onPlayerReadyDance(media[24])"
                style="bottom: 18%; left: 28%; width: 22%; font-size: 1em; border-bottom:none !important"
              >Click to Play</a>
            </div>
            <div :style="'background-image:url(' + pages1[324] + ')'">
              <div class="pbm_right">
                <img :src="media[26]" alt="pretty_big_movement" height="750%" width="824%" />
              </div>
            </div>
            <div :style="'background-image:url(' + pages1[325] + ')'"></div>
            <div :style="'background-image:url(' + pages1[326] + ')'"></div>
            <div :style="'background-image:url(' + pages1[327] + ')'"></div>
            <div :style="'background-image:url(' + pages1[328] + ')'"></div>
            <div :style="'background-image:url(' + pages1[329] + ')'"></div>
            <div :style="'background-image:url(' + pages1[330] + ')'"></div>
            <div :style="'background-image:url(' + pages1[331] + ')'"></div>
            <div :style="'background-image:url(' + pages1[332] + ')'"></div>
            <div :style="'background-image:url(' + pages1[333] + ')'"></div>
            <div :style="'background-image:url(' + pages1[334] + ')'"></div>
            <div :style="'background-image:url(' + pages1[335] + ')'"></div>
            <div :style="'background-image:url(' + pages1[336] + ')'"></div>
            <div :style="'background-image:url(' + pages1[337] + ')'"></div>
            <div :style="'background-image:url(' + pages1[338] + ')'"></div>
            <div :style="'background-image:url(' + pages1[339] + ')'"></div>
            <div :style="'background-image:url(' + pages1[340] + ')'">
              <a
                class="links articles"
                style="bottom:7%; left:55.6%; width: 13.5%"
                target="_blank"
                @click="openLink('http://www.maavven.com/')"
              >http://www.maavven.com/</a>
            </div>
            <div :style="'background-image:url(' + pages1[341] + ')'"></div>
            <div :style="'background-image:url(' + pages1[342] + ')'"></div>
            <div :style="'background-image:url(' + pages1[343] + ')'"></div>
            <div :style="'background-image:url(' + pages1[344] + ')'">
              <a
                class="links articles"
                style="bottom:7%; left:57%; width: 28.5%"
                target="_blank"
                @click="openLink('https://www.instagram.com/dalischonfelder/')"
              >https://www.instagram.com/dalischonfelder/</a>
            </div>
            <div :style="'background-image:url(' + pages1[345] + ')'"></div>
            <div :style="'background-image:url(' + pages1[346] + ')'"></div>
            <div :style="'background-image:url(' + pages1[347] + ')'"></div>
            <div :style="'background-image:url(' + pages1[348] + ')'">
              <vue-player
                ref="video9"
                id="phoebe_star"
                src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-1%2Fmedia%2Fpg349_phebe_starr_feel_my_love_official_lyric_video.mp4?alt=media&token=864010a4-3de5-4880-ac69-f4c553dc91e6"
                :poster="media[27]"
              ></vue-player>
            </div>
            <div :style="'background-image:url(' + pages1[349] + ')'"></div>
            <div :style="'background-image:url(' + pages1[350] + ')'"></div>
            <div :style="'background-image:url(' + pages1[351] + ')'"></div>
            <div :style="'background-image:url(' + pages1[352] + ')'"></div>
            <div :style="'background-image:url(' + pages1[353] + ')'"></div>
            <div :style="'background-image:url(' + pages1[354] + ')'"></div>
            <div :style="'background-image:url(' + pages1[355] + ')'"></div>
            <div :style="'background-image:url(' + pages1[356] + ')'"></div>
            <div :style="'background-image:url(' + pages1[357] + ')'"></div>
            <div :style="'background-image:url(' + pages1[358] + ')'">
              <a
                class="links articles"
                style="bottom:50.4%; left:57.5%; width: 13%"
                target="_blank"
                @click="openLink('https://www.instagram.com/oceanpleasant')"
              >oceanpleasant</a>
            </div>
            <div :style="'background-image:url(' + pages1[359] + ')'"></div>
            <div :style="'background-image:url(' + pages1[360] + ')'">
              <a
                class="links articles"
                style="bottom:7%; left:55.5%; width: 29%"
                target="_blank"
                @click="openLink('https://thisisbeautymart.com/')"
              >https://thisisbeautymart.com/</a>
            </div>
            <div :style="'background-image:url(' + pages1[361] + ')'"></div>
            <div :style="'background-image:url(' + pages1[362] + ')'"></div>
            <div :style="'background-image:url(' + pages1[363] + ')'"></div>
            <div :style="'background-image:url(' + pages1[364] + ')'"></div>
            <div :style="'background-image:url(' + pages1[365] + ')'"></div>
            <div :style="'background-image:url(' + pages1[366] + ')'"></div>
            <div :style="'background-image:url(' + pages1[367] + ')'"></div>
            <div :style="'background-image:url(' + pages1[368] + ')'"></div>
            <div :style="'background-image:url(' + pages1[369] + ')'"></div>
            <div :style="'background-image:url(' + pages1[370] + ')'"></div>
            <div :style="'background-image:url(' + pages1[371] + ')'"></div>
            <div :style="'background-image:url(' + pages1[372] + ')'"></div>
            <div :style="'background-image:url(' + pages1[373] + ')'"></div>
            <div :style="'background-image:url(' + pages1[374] + ')'"></div>
            <div :style="'background-image:url(' + pages1[375] + ')'"></div>
            <div :style="'background-image:url(' + pages1[376] + ')'"></div>
            <div :style="'background-image:url(' + pages1[377] + ')'">
              <div class="solver_left">
                <img :src="media[29]" alt="solve" height="750%" width="824%" />
              </div>
              <a
                class="links"
                @click="onPlayerReadyMm2(media[28])"
                style="bottom: 18%; left: 28%; width: 22%; font-size: 1em; border-bottom:none !important"
              >Click to Play</a>
            </div>
            <div :style="'background-image:url(' + pages1[378] + ')'">
              <div class="solver_right">
                <img :src="media[30]" alt="solve" height="750%" width="824%" />
              </div>
            </div>
            <div :style="'background-image:url(' + pages1[379] + ')'">
              <a
                class="links articles"
                style="bottom:7%; left:52.5%; width: 26%"
                target="_blank"
                @click="openLink('https://www.instagram.com/harshcrowd/')"
              >https://www.instagram.com/harshcrowd/</a>
            </div>
            <div :style="'background-image:url(' + pages1[380] + ')'"></div>
            <div :style="'background-image:url(' + pages1[381] + ')'"></div>
            <div :style="'background-image:url(' + pages1[382] + ')'"></div>
            <div :style="'background-image:url(' + pages1[383] + ')'"></div>
            <div :style="'background-image:url(' + pages1[384] + ')'"></div>
            <div :style="'background-image:url(' + pages1[385] + ')'"></div>
            <div :style="'background-image:url(' + pages1[386] + ')'"></div>
            <div :style="'background-image:url(' + pages1[387] + ')'"></div>
            <div :style="'background-image:url(' + pages1[388] + ')'"></div>
            <div :style="'background-image:url(' + pages1[389] + ')'"></div>
            <div :style="'background-image:url(' + pages1[390] + ')'"></div>
            <div :style="'background-image:url(' + pages1[391] + ')'"></div>
            <div :style="'background-image:url(' + pages1[392] + ')'"></div>
            <div :style="'background-image:url(' + pages1[393] + ')'"></div>
            <div :style="'background-image:url(' + pages1[394] + ')'"></div>
            <div :style="'background-image:url(' + pages1[395] + ')'"></div>
            <div :style="'background-image:url(' + pages1[396] + ')'"></div>
            <div :style="'background-image:url(' + pages1[397] + ')'"></div>
            <div :style="'background-image:url(' + pages1[398] + ')'"></div>
            <div :style="'background-image:url(' + pages1[399] + ')'"></div>
            <div :style="'background-image:url(' + pages1[400] + ')'"></div>
            <div :style="'background-image:url(' + pages1[401] + ')'"></div>
            <div :style="'background-image:url(' + pages1[402] + ')'"></div>
            <div :style="'background-image:url(' + pages1[403] + ')'"></div>
            <div :style="'background-image:url(' + pages1[404] + ')'"></div>
            <div :style="'background-image:url(' + pages1[405] + ')'"></div>
            <div :style="'background-image:url(' + pages1[406] + ')'"></div>
            <div :style="'background-image:url(' + pages1[407] + ')'"></div>
            <div :style="'background-image:url(' + pages1[408] + ')'"></div>
            <div :style="'background-image:url(' + pages1[409] + ')'"></div>
            <div :style="'background-image:url(' + pages1[410] + ')'"></div>
            <div :style="'background-image:url(' + pages1[411] + ')'"></div>
            <div :style="'background-image:url(' + pages1[412] + ')'"></div>
            <div :style="'background-image:url(' + pages1[413] + ')'"></div>
            <div :style="'background-image:url(' + pages1[414] + ')'"></div>
            <div :style="'background-image:url(' + pages1[415] + ')'"></div>
            <div :style="'background-image:url(' + pages1[416] + ')'"></div>
            <div :style="'background-image:url(' + pages1[417] + ')'"></div>
            <div :style="'background-image:url(' + pages1[418] + ')'"></div>
            <div :style="'background-image:url(' + pages1[419] + ')'"></div>
            <div :style="'background-image:url(' + pages1[420] + ')'"></div>
            <div :style="'background-image:url(' + pages1[421] + ')'"></div>
            <div :style="'background-image:url(' + pages1[422] + ')'"></div>
            <div :style="'background-image:url(' + pages1[423] + ')'"></div>
            <div :style="'background-image:url(' + pages1[424] + ')'"></div>
            <div :style="'background-image:url(' + pages1[425] + ')'"></div>
            <div :style="'background-image:url(' + pages1[426] + ')'"></div>
            <div :style="'background-image:url(' + pages1[427] + ')'"></div>
            <div :style="'background-image:url(' + pages1[428] + ')'"></div>
            <div :style="'background-image:url(' + pages1[429] + ')'"></div>
            <div :style="'background-image:url(' + pages1[430] + ')'">
              <iframe
                id="freak"
                src="https://www.youtube.com/embed/M1XzzDua-N8"
                frameborder="0"
                allowfullscreen
              ></iframe>
            </div>
            <div :style="'background-image:url(' + pages1[431] + ')'"></div>
            <div :style="'background-image:url(' + pages1[432] + ')'"></div>
            <div :style="'background-image:url(' + pages1[433] + ')'"></div>
            <div :style="'background-image:url(' + pages1[434] + ')'"></div>
            <div :style="'background-image:url(' + pages1[435] + ')'"></div>
            <div :style="'background-image:url(' + pages1[436] + ')'"></div>
            <div :style="'background-image:url(' + pages1[437] + ')'"></div>
            <div :style="'background-image:url(' + pages1[438] + ')'"></div>
            <div :style="'background-image:url(' + pages1[439] + ')'"></div>
            <div :style="'background-image:url(' + pages1[440] + ')'">
              <a
                class="minilinks articles"
                style="bottom:7%; left:41.5%; width: 14%"
                target="_blank"
                @click="openLink('mailto:info@missionmag.org')"
              >info@missionmag.org</a>
            </div>
            <div :style="'background-image:url(' + pages1[441] + ')'"></div>
          </div>
          <div class="flipbook-video video-content" id="video-mm" v-show="verMm">
            <b-embed
               type="video"
              :src="infoModalMm.src"
              :poster="infoModalMm.poster" 
              id="videoMm"
              autoplay
              allow="autoplay"
              :controls="false"
              allowfullscreen>

            </b-embed>
          </div>
          <div class="flipbook-video video-content" id="video-lips" v-show="verLips">
          <b-embed
              type="video"
            :src="infoModalLips.src"
            
            id="videoLips"
            autoplay
            allow="autoplay"
            :controls="false"
            allowfullscreen>

          </b-embed>
        </div>
          <div class="flipbook-video video-content" id="video-skate" v-show="verSkate">
          <b-embed
              type="video"
            :src="infoModalSkate.src"
           
            id="videoSkate"
            autoplay
            allow="autoplay"
            :controls="false"
            allowfullscreen>

          </b-embed>
        </div>
           <div class="flipbook-video video-content" id="video-band" v-show="verBand">
          <b-embed
              type="video"
            :src="infoModalBand.src"
            
            id="videoBand"
            autoplay
            allow="autoplay"
            :controls="false"
            allowfullscreen>
          </b-embed>
        </div>
        <div class="flipbook-video video-content" id="video-sesame" v-show="verSesame">
          <b-embed
              type="video"
            :src="infoModalSesame.src"
            
            id="videoSesame"
            autoplay
            allow="autoplay"
            :controls="false"
            allowfullscreen>
          </b-embed>
        </div>
        <div class="flipbook-video video-content" id="video-dance" v-show="verDance">
          <b-embed
              type="video"
            :src="infoModalDance.src"
            
            id="videoDance"
            autoplay
            allow="autoplay"
            :controls="false"
            allowfullscreen>
          </b-embed>
        </div>
        <div class="flipbook-video video-content" id="video-mm2" v-show="verMm2">
          <b-embed
              type="video"
            :src="infoModalMm2.src"
            
            id="videoMm2"
            autoplay
            allow="autoplay"
            :controls="false"
            allowfullscreen>
          </b-embed>
        </div>        
        </div>
        <index v-if="index"></index>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import '@/lib/turn.js';
import '@/lib/zoom.js';
import '@/lib/hash.js'
import index from './Index'
import loader from "../../containers/loader";
import {
  mapState,
  mapActions,
  mapMutations
} from "vuex";
import vuePlayer from '@algoz098/vue-player'

export default {
  components: {
    index,
    loader,
    vuePlayer
  },
  data() {
    return {
      estado: '/issue-1',
      infoModalMm: {
        src: '',        
        isPlay:false
      },
      verMm:false,
        infoModalLips: {
        src: '',        
        isPlay:false
      },
      verLips:false,
      infoModalSkate: {
        src: '',        
        isPlay:false
      },
      verSkate:false,
      infoModalBand: {
        src: '',        
        isPlay:false
      },
      verBand:false,
      infoModalSesame: {
        src: '',        
        isPlay:false
      },
      verSesame:false,
    
      infoModalDance: {
        src: '',        
        isPlay:false
      },
      verDance:false,
      infoModalMm2: {
        src: '',        
        isPlay:false
      },
      verMm2:false,
    }
  },
  async created() {

    await this.loadMagazine1()

  },
  mounted() {

    function loadApp() {
      $("#canvas").fadeIn(3000);
      var o = $(".flipbook");
      0 != o.width() && 0 != o.height() ? (o.turn({
        width: 1580,
        height: 990,
        duration: 3000,
        acceleration: !isChrome(),
        gradients: !0,
        autoCenter: !0,
        elevation: 200,
        when: {
          turning: function (o, i, n) {
            var e = $(this),
              a = e.turn("page");
            e.turn("pages");
            $("#video-mm").hide();
            disableControls(i),
              $(".thumbnails .page-" + a).parent().removeClass("current"),
              $(".thumbnails .page-" + i).parent().addClass("current")
          },
          turned: function (o, i, n) {
            disableControls(i), $(this).turn("center"), 1 == i && $(this).turn("peel", "br")
          },
          missing: function (o, i) {
            for (var n = 0; n < i.length; n++) addPage(i[n], $(this))
          }
        }
      }), $(".flipbook-viewport").zoom({
        flipbook: $(".flipbook"),
        max: function () {
          return largeMagazineWidth() / $(".flipbook").width()
        },
        when: {
          swipeLeft: function () {
            $(this).zoom("flipbook").turn("next")
          },
          swipeRight: function () {
            $(this).zoom("flipbook").turn("previous")
          },
          resize: function (o, i, n, e) {
            1 == i ? loadSmallPage(n, e) : loadLargePage(n, e)
          },
          zoomIn: function () {
            $(".thumbnails").hide(), $(".made").hide(), $(".flipbook").removeClass("animated").addClass("zoom-in"), $(".zoom-icon").removeClass("zoom-icon-in").addClass("zoom-icon-out"), window.escTip || $.isTouch || (escTip = !0)
          },
          zoomOut: function () {
            $(".exit-message").hide(), $(".made").fadeIn(), $(".zoom-icon").removeClass("zoom-icon-out").addClass("zoom-icon-in"), setTimeout(function () {
              $(".flipbook").addClass("animated").removeClass("zoom-in"), resizeViewport()
            }, 0)
          }
        }
      }),
        $(document).keydown(function (e) {
          var options = $('.flipbook').turn('options');

          var previous = 37,
            next = 39,
            esc = 27;

          switch (e.keyCode) {
            case previous:

              // left arrow
              $('.flipbook').turn('previous');
              e.preventDefault();

              break;
            case next:
              //right arrow
              $('.flipbook').turn('next');
              e.preventDefault();


              break;
            case esc:
              $(".flipbook").turn("size", options.width, options.height);

              // $('.flipbook-viewport').zoom('zoomOut');
              e.preventDefault();

              break;
          }
        }),
        $(window).resize(function () {
          resizeViewport()
        }).bind("orientationchange", function () {
          resizeViewport()
        }),
        // $.isTouch ? $(".flipbook").bind("touchstart", regionClick) : $(".flipbook").click(regionClick), 
        resizeViewport(),
        $(".flipbook").addClass("animated")) : setTimeout(loadApp, 10)
    }
    $(".zoom-icon").bind("mouseover", function () {
      $(this).hasClass("zoom-icon-in") && $(this).addClass("zoom-icon-in-hover"),
        $(this).hasClass("zoom-icon-out") && $(this).addClass("zoom-icon-out-hover")
    }).on("mouseout", function () {
      $(this).hasClass("zoom-icon-in") && $(this).removeClass("zoom-icon-in-hover"),
        $(this).hasClass("zoom-icon-out") && $(this).removeClass("zoom-icon-out-hover")
    }).on("click", function () {
      toggleFullscreen()
    }), $("#canvas").hide()

    //FUNCTIONS TURNJS

    function resizeViewport() {

      var width = $(window).width(),
        height = $(window).height(),
        options = $('.flipbook').turn('options');

      $('.flipbook').removeClass('animated');

      $('.flipbook-viewport').css({
        width: width,
        height: height
      }).zoom('resize');

      if ($('.flipbook').turn('zoom') == 1) {
        var bound = calculateBound({
          width: options.width,
          height: options.height,
          boundWidth: Math.min(options.width, width),
          boundHeight: Math.min(options.height, height)
        });

        if (bound.width % 2 !== 0)
          bound.width -= 1;

        if (bound.width != $('.flipbook').width() || bound.height != $('.flipbook').height()) {

          $('.flipbook').turn('size', bound.width, bound.height);

          if ($('.flipbook').turn('page') == 1)
            $('.flipbook').turn('peel', 'br');

          $('.next-button').css({
            height: bound.height,
            backgroundPosition: '-38px ' + (bound.height / 2 - 32 / 2) + 'px'
          });
          $('.previous-button').css({
            height: bound.height,
            backgroundPosition: '-4px ' + (bound.height / 2 - 32 / 2) + 'px'
          });
        }

        $('.flipbook').css({
          top: -bound.height / 2,
          left: -bound.width / 2
        });
                $(".flipbook-video").css({
          width: bound.width,
          height: bound.height,
          top: -bound.height / 2,
          left: -bound.width / 2,
          padding: 15,
        });
      }

      var magazineOffset = $('.flipbook').offset(),
        boundH = height - magazineOffset.top - $('.flipbook').height(),
        marginTop = (boundH - $('.thumbnails > div').height()) / 2;

      if (marginTop < 0) {
        $('.thumbnails').css({
          height: 1
        });
      } else {
        $('.thumbnails').css({
          height: boundH
        });
        $('.thumbnails > div').css({
          marginTop: marginTop
        });
      }

      if (magazineOffset.top < $('.made').height())
        $('.made').hide();
      else
        $('.made').show();

      $('.flipbook').addClass('animated');

    }

    function isChrome() {
      return navigator.userAgent.indexOf('Chrome') != -1;
    }

    function calculateBound(d) {

      var bound = {
        width: d.width,
        height: d.height
      };

      if (bound.width > d.boundWidth || bound.height > d.boundHeight) {

        var rel = bound.width / bound.height;

        if (d.boundWidth / rel > d.boundHeight && d.boundHeight * rel <= d.boundWidth) {

          bound.width = Math.round(d.boundHeight * rel);
          bound.height = d.boundHeight;

        } else {

          bound.width = d.boundWidth;
          bound.height = Math.round(d.boundWidth / rel);

        }
      }

      return bound;
    }

    function toggleFullscreen(elem) {
      var options = $('.flipbook').turn('options');

      elem = elem || document.documentElement;
      if (!document.fullscreenElement && !document.mozFullScreenElement &&
        !document.webkitFullscreenElement && !document.msFullscreenElement) {

        if (elem.requestFullscreen) {
          elem.requestFullscreen();
          $(".flipbook").turn("zoom", 1.20);
          $(".flipbook").turn("center");
          $(".flipbook").addClass("animated")
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen();
          $(".flipbook").turn("zoom", 1.20);
          $(".flipbook").turn("center");
          $(".flipbook").addClass("animated")
        } else if (elem.mozRequestFullScreen) {
          elem.mozRequestFullScreen();
          $(".flipbook").turn("zoom", 1.20);
          $(".flipbook").turn("center");
          $(".flipbook").addClass("animated")
        } else if (elem.webkitRequestFullscreen) {
          elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
          $(".flipbook").turn("zoom", 1.20);
          $(".flipbook").turn("center");
          $(".flipbook").addClass("animated")
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          $(".flipbook").turn("zoom", 1);
          //$(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
          //$(".flipbook").turn("zoom", 1);
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
          //$(".flipbook").turn("zoom", 1);
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
          //$(".flipbook").turn("zoom", 1);
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
          //$(".flipbook").turn("zoom", 1);
        }
      }
    }

    function disableControls(page) {
      if (page == 1)
        $('.previous-button').hide();
      else
        $('.previous-button').show();

      if (page == $('.flipbook').turn('pages'))
        $('.next-button').hide();
      else
        $('.next-button').show();
    }

    function loadSmallPage(page, pageElement) {

      var img = pageElement.find('img');

      img.css({
        width: '100%',
        height: '100%'
      });

      img.unbind('load');
      // Loadnew page

      //  img.attr('src', 'pages/' + page + '.jpg');
    }

    // large page
    function loadLargePage(page, pageElement) {
      var img = $('<img />');
      img.load(function () {

        var prevImg = pageElement.find('img');
        $(this).css({
          width: '100%',
          height: '100%'
        });
        $(this).appendTo(pageElement);
        prevImg.remove();

      });

      // Loadnew page

      //  img.attr('src', 'pages/' + page + '-large.jpg');
    }

    loadApp()

  },
  methods: {

        onPlayerReadyMm(reproducir) {
      this.infoModalMm.isPlay = true;
      this.infoModalMm.src = reproducir;
      /* this.infoModalMm.poster = mini; */
      setTimeout(() => {
        const media = document.getElementById("videoMm");
        media.load();
        media.play();
        this.infoModalMm.isPlay = true;
        this.verMm = true;
      }, 100);
    },
      onPlayerReadyLips(reproducir) {
      this.infoModalLips.isPlay = true;
      this.infoModalLips.src = reproducir;
      /* this.infoModalLips.poster = mini; */
      setTimeout(() => {
        const media = document.getElementById("videoLips");
        media.load();
        media.play();
        this.infoModalLips.isPlay = true;
        this.verLips = true;
      }, 100);
    },
      onPlayerReadySkate(reproducir) {
      this.infoModalSkate.isPlay = true;
      this.infoModalSkate.src = reproducir;
      /* this.infoModalSkate.poster = mini; */
      setTimeout(() => {
        const media = document.getElementById("videoSkate");
        media.load();
        media.play();
        this.infoModalSkate.isPlay = true;
        this.verSkate = true;
      }, 100);
    },
      onPlayerReadyBand(reproducir) {
      this.infoModalBand.isPlay = true;
      this.infoModalBand.src = reproducir;
      /* this.infoModalBand.poster = mini; */
      setTimeout(() => {
        const media = document.getElementById("videoBand");
        media.load();
        media.play();
        this.infoModalBand.isPlay = true;
        this.verBand = true;
      }, 100);
    },
      onPlayerReadySesame(reproducir) {
      this.infoModalSesame.isPlay = true;
      this.infoModalSesame.src = reproducir;
      /* this.infoModalSesame.poster = mini; */
      setTimeout(() => {
        const media = document.getElementById("videoSesame");
        media.load();
        media.play();
        this.infoModalSesame.isPlay = true;
        this.verSesame = true;
      }, 100);
    },
      onPlayerReadyDance(reproducir) {
      this.infoModalDance.isPlay = true;
      this.infoModalDance.src = reproducir;
      /* this.infoModalDance.poster = mini; */
      setTimeout(() => {
        const media = document.getElementById("videoDance");
        media.load();
        media.play();
        this.infoModalDance.isPlay = true;
        this.verDance = true;
      }, 100);
    },
      onPlayerReadyMm2(reproducir) {
      this.infoModalMm2.isPlay = true;
      this.infoModalMm2.src = reproducir;
      /* this.infoModalMm2.poster = mini; */
      setTimeout(() => {
        const media = document.getElementById("videoMm2");
        media.load();
        media.play();
        this.infoModalMm2.isPlay = true;
        this.verMm2 = true;
      }, 100);
    },
    openLink(url) {
      window.open(url)
    },
    openBook() {
      let route = this.$router.resolve('/colorbook/1'); // This also works.
      window.open(route.href, '_blank');
    },
    pause() {
        if (this.infoModalMm.isPlay == true) {
        const media = document.getElementById("videoMm");
        media.pause();
        this.verMm = false;
        this.infoModalMm.isPlay = false;
      }
       if (this.infoModalLips.isPlay == true) {
        const media = document.getElementById("videoLips");
        media.pause();
        this.verLips = false;
        this.infoModalLips.isPlay = false;
      }
       if (this.infoModalSkate.isPlay == true) {
        const media = document.getElementById("videoSkate");
        media.pause();
        this.verSkate = false;
        this.infoModalSkate.isPlay = false;
      }
       if (this.infoModalBand.isPlay == true) {
        const media = document.getElementById("videoBand");
        media.pause();
        this.verBand = false;
        this.infoModalBand.isPlay = false;
      }
      if (this.infoModalSesame.isPlay == true) {
        const media = document.getElementById("videoSesame");
        media.pause();
        this.verSesame = false;
        this.infoModalSesame.isPlay = false;
      }
      if (this.infoModalDance.isPlay == true) {
        const media = document.getElementById("videoDance");
        media.pause();
        this.verDance = false;
        this.infoModalDance.isPlay = false;
      }
         if (this.infoModalMm2.isPlay == true) {
        const media = document.getElementById("videoMm2");
        media.pause();
        this.verMm2 = false;
        this.infoModalMm2.isPlay = false;
      }
      if (this.$refs.video1.playing == true) {
        this.$refs.video1.playing == false
        this.$refs.video1.$refs.video.pause()
      }
      if (this.$refs.video2.playing == true) {
        this.$refs.video2.playing == false
        this.$refs.video2.$refs.video.pause()
      }
      if (this.$refs.video3.playing == true) {
        this.$refs.video3.playing == false
        this.$refs.video3.$refs.video.pause()
      }
      if (this.$refs.video4.playing == true) {
        this.$refs.video4.playing == false
        this.$refs.video4.$refs.video.pause()
      }
      if (this.$refs.video5.playing == true) {
        this.$refs.video5.playing == false
        this.$refs.video5.$refs.video.pause()
      }
      if (this.$refs.video6.playing == true) {
        this.$refs.video6.playing == false
        this.$refs.video6.$refs.video.pause()
      }
      if (this.$refs.video7.playing == true) {
        this.$refs.video7.playing == false
        this.$refs.video7.$refs.video.pause()
      }
      if (this.$refs.video8.playing == true) {
        this.$refs.video8.playing == false
        this.$refs.video8.$refs.video.pause()
      }
      if (this.$refs.video9.playing == true) {
        this.$refs.video9.playing == false
        this.$refs.video9.$refs.video.pause()
      }

    },
    pageNext() {
      $('.flipbook').turn('next');
      this.pause()
    },
    pagePrev() {
      $('.flipbook').turn('previous');;
      this.pause()
    },

    cambiarEstado(newEstado) {
      this.estado = newEstado;
      if (newEstado == '/index') {
        this.setClass(true)
      } else {
        this.$router.push(this.estado)
        this.setClass(false)
      }
    },

    ...mapActions('magazine', [
      'loadMagazine1'
    ]),
    ...mapMutations('magazine', [
      'setClass',
      "loadSmallPage",
      "loadLargePage",
    ]),
  },
  computed: {
    ...mapState('magazine', [
      'index',
      'pages1',
      'loading',
      'media'
    ])
  },

}
</script>

<style lang="scss" src="../../assets/issue.scss"></style>
<style lang="scss">
video {
  object-fit: cover !important;
}
.size-124 {
  font-size: 30px !important;
}

.video-content {
  .embed-responsive {
    position: absolute;
    z-index: 1000;
    top: 9%;
    left: 14.5%;
    width: 74.1%;
    height: 67.5%;

  }
}

.start-button {
  width: auto;
  height: auto;
  border: none !important;
  background-color: rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.vue-video-player-controls {
  max-height: 30px;
  display: flex;
  left: 7% !important;
  right: 7% !important;
  padding: 5px;
  position: absolute;
  bottom: 14% !important;
  background-color: rgba(0, 0, 0, 0) !important;
}

.button {
  width: 35px;
  border: none !important;
  color: white;
  background-color: transparent;
}
#youtube-link {
  position: absolute;
  margin-left: 31%;
  margin-top: 56%;
  z-index: 999999;
  visibility: hidden;
}
</style>
